export const completeItemsMixin = {
    methods: {
        /**
         *
         * @param items
         */
        completeItems(items) {
            const payload = []

            items.forEach(item => {
                payload.push({
                    artikelNrLAG: item.artikelNrLAG,
                    ownerType: item.ownerType,
                    ownerId: item.ownerId,
                    quantity: item.orderedQuantity - item.deliveredBefore
                })
            })

            this.update(payload)
        },

        /**
         *
         * @param items
         */
        resetItems(items) {
            const payload = []

            items.forEach(item => {
                payload.push({
                    artikelNrLAG: item.artikelNrLAG,
                    ownerType: item.ownerType,
                    ownerId: item.ownerId,
                    quantity: 0
                })
            })

            this.update(payload)
        },

        /**
         *
         * @param items
         */
        update(items) {
            this.$store.dispatch('smartLogisticWarehouse/updateItemBatch', {
                partialDeliveryId: this.currentlyOpenPartialDelivery.id,
                batch: items
            })
        },
    },
}